<template>
  <div class="confirm-image">
    <img :src="fileSrc" class="img-fluid"/>
    <div>{{fileName}}</div>
  </div>
</template>

<script>
import { getFileSrcToBase64 } from '../../utils/ImageHelper'
export default {
  name: 'confirm-image',
  props: ['fileName', 'fileData'],
  computed: {
    fileSrc: function () {
      return getFileSrcToBase64(this.fileData, this.fileName)
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/stylesheets/styles";
  .confirm-image {
    background-color: $light;
    border: 1px solid $secondary;
    padding: 20px;
    text-align: center;
    word-break: break-all;
    @include mq-up(md) {
      padding: 40px;
    }
    img {
      border: 1px solid $secondary;
      margin-bottom: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/upload/ConfirmImage.vue